var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbol(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 64,
    viewBox: "0 0 44 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_95_98)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.0117 32C22.0117 26.169 26.7387 21.4419 32.5698 21.4419C38.4008 21.4419 43.1279 26.169 43.1279 32C43.1279 37.8311 38.4008 42.558 32.5698 42.558C26.7387 42.558 22.0117 37.8311 22.0117 32Z",
    fill: "#1ABCFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.895508 53.1162C0.895508 47.2852 5.62251 42.5581 11.4536 42.5581H22.0116V53.1162C22.0116 58.9473 17.2847 63.6743 11.4536 63.6743C5.62251 63.6743 0.895508 58.9473 0.895508 53.1162Z",
    fill: "#0ACF83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.0117 0.325684V21.4418H32.5698C38.4009 21.4418 43.1279 16.7148 43.1279 10.8837C43.1279 5.0527 38.4009 0.325684 32.5698 0.325684H22.0117Z",
    fill: "#FF7262"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.895508 10.8838C0.895508 16.7148 5.62251 21.4418 11.4536 21.4418H22.0116V0.325684H11.4536C5.62251 0.325684 0.895508 5.05269 0.895508 10.8838Z",
    fill: "#F24E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.895508 32C0.895508 37.8311 5.62251 42.558 11.4536 42.558H22.0116V21.4419H11.4536C5.62251 21.4419 0.895508 26.169 0.895508 32Z",
    fill: "#A259FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_95_98"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42.6667,
    height: 64,
    fill: "white",
    transform: "translate(0.678711)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbol);
export default __webpack_public_path__ + "static/media/Symbol.725f0eeb1be26c77ad1cb2a835e9cc55.svg";
export { ForwardRef as ReactComponent };